export default __webpack_public_path__ + "static/extended-data-details-ddb0eca79bbfd8eb535fea7a82727ed0.png";